import { nodeHttpLink } from '@seek/ca-graphql-client/node';
import { createContext } from 'react';

import { devConfig } from 'src/config';
import { RECOMMENDED_JOBS_ROUTE_NAME } from 'src/constants';
import type { Route } from 'src/types';

import type { AppConfig } from './AppConfigProvider';

const initialConfig: AppConfig = {
  ...devConfig,
  environment: 'development',
  httpLink: nodeHttpLink,
  country: 'au',
  route: RECOMMENDED_JOBS_ROUTE_NAME as Route,
  site: 'candidate-seek-au',
  language: 'en',
};

const Context = createContext<AppConfig>(initialConfig);

export default Context;
